import { useAtomValue } from 'jotai';

import { connectedAtAtom } from '../video-sdk';
import { InSessionTimer } from './InSessionTimer';

export function InSessionTimerWrapper() {
  const connectedAt = useAtomValue(connectedAtAtom);

  return <InSessionTimer connectedAt={connectedAt} getCurrentTimestamp={() => Date.now()} />;
}
